<template>
  <div class="row">
    <div class="col-sm-12">
      <PreferenceConfigList
        v-model="classificationConfig"
        :program-id="programId"
      />
    </div>
  </div>
</template>

<script>
import PreferenceConfigList from '@/employees/components/PreferenceConfig/PreferenceConfigList'
import { CLASSIFICATION_CONFIG_GROUP, CLASSIFICATION_CONFIG_SUBSCRIBABLE_GROUPING } from '@/constants'

export default {
  name: 'ClassificationConfig',
  components: { PreferenceConfigList },
  props: {
    value: {
      required: true,
      type: Object,
    },
    modelValues: {
      required: true,
      type: Object,
    },
    errors: {
      required: false,
      default: () => {},
      type: Object,
    },
  },

  data () {
    return {
      group: CLASSIFICATION_CONFIG_GROUP,
      subscribableGrouping: CLASSIFICATION_CONFIG_SUBSCRIBABLE_GROUPING,
      isLoading: false,
      programId: null,
      subscribables: [],
    }
  },

  computed: {
    classificationConfig: {
      get () {
        return this.value.classificationConfig
      },
      set (value) {
        this.emitInput('classificationConfig', value)
      },
    },
  },

  async created () {
    if (this.modelValues.modelType === this.subscribableGrouping) {
      this.isLoading = true
      this.programId = this.modelValues.model[0].program_id

      await this.$store.dispatch('getSubscribableGroupingSubscribables', {
        subscribableGroupingId: this.modelValues.model[0].id,
      }).then((response) => {
        this.subscribables = response.data.data.data

        this.setSubscribablesInStoreForRules()
      }).finally(() => {
        this.isLoading = false
      })
    } else if (this.modelValues.modelType === this.group) {
      this.isLoading = true
      this.programId = this.modelValues.model[0].program_id

      await this.$store.dispatch('getSubscribables', {
        apiRoute: '/employee/subscribables/api',
        queryParams: {
          filter: {
            active: true,
          },
        },
      }).then((response) => {
        this.subscribables = response.subscribables

        this.setSubscribablesInStoreForRules()
      }).finally(() => {
        this.isLoading = false
      })
    }

    this.$emit('canFinishStep')
  },

  methods: {
    emitInput (key, value) {
      const newValue = { ...this.value, [key]: value }

      this.$emit('input', newValue)
    },

    getErrorMessage (field) {
      if (this.errors && Object.keys(this.errors).includes(field)) {
        return this.errors[field].join(' ')
      }
    },

    setSubscribablesInStoreForRules () {
      const storeSubscribables = {}

      this.subscribables.forEach(subscribable => {
        storeSubscribables[subscribable.id] = subscribable.name
      })

      this.$store.dispatch('set_rule_subscribables', storeSubscribables)
      this.$store.dispatch('set_selector_subscribables', storeSubscribables)
    },
  },
}
</script>

<style scoped>
  .classification-config {
    margin-top: 25px;
  }
</style>
